import { META } from './data';

export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#0E1B2D] text-[#F4EFE5] mt-24">
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-16 grid md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10">
        <div>
          <p className="font-serif italic text-5xl">{META.brand}</p>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C2A36B] mt-2">{META.tag}</p>
          <p className="text-sm text-[#F4EFE5]/55 mt-5 leading-[1.7] max-w-md">A licensed brokerage representing trophy private residences across three continents. Inquiries are confidential and answered by name.</p>
          <p className="font-mono text-[9px] tracking-[0.32em] uppercase text-[#C2A36B]/70 mt-6">{META.license}</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C2A36B] mb-3">East Hampton</p>
          <p className="text-sm text-[#F4EFE5]/85 leading-relaxed">31 Newtown Lane<br />East Hampton, NY 11937</p>
          <p className="font-mono text-[11px] text-[#F4EFE5]/55 mt-3">+1 (212) 555 0118</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C2A36B] mb-3">Aspen</p>
          <p className="text-sm text-[#F4EFE5]/85 leading-relaxed">408 South Mill Street<br />Aspen, CO 81611</p>
          <p className="font-mono text-[11px] text-[#F4EFE5]/55 mt-3">+1 (970) 555 0119</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C2A36B] mb-3">Saint-Tropez</p>
          <p className="text-sm text-[#F4EFE5]/85 leading-relaxed">12 Place de la Garonne<br />83990 Saint-Tropez, FR</p>
          <p className="font-mono text-[11px] text-[#F4EFE5]/55 mt-3">+33 4 94 555 0120</p>
        </div>
      </div>
      <div className="border-t border-[#F4EFE5]/15 px-8 lg:px-14 py-5 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-[#F4EFE5]/40">
        <span>© 2026 {META.brand} · Licensed real estate broker · NY · CO · FR</span>
        <div className="flex gap-6">
          <button onClick={() => setPage('inventory')} className="hover:text-[#C2A36B]">Inventory</button>
          <button onClick={() => setPage('viewing')} className="hover:text-[#C2A36B]">Viewings</button>
        </div>
      </div>
    </footer>
  );
}
